module.exports = "/packs/images/svg/facilities/ski~db34d77827bd0f0b96eb4d9c91bd4773.svg";